import styled from 'styled-components';

const HeaderPanel = styled.div`
    height: 100%;
    background-color: #344a61;
    grid-column: page-start / page-end;
    grid-row: header-top / header-bottom;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 12px 24px;
`;

export default HeaderPanel;
